<template>
  <div>
    <ContextLogin
      :redirectTo="redirectTo"
      :context="context"
      headerText="Log in to your application using JumpCloud"
      submitButtonText="SSO Login"
      :clientType="clientType"
      :completeRedirectUrl="completeRedirectUrl"
    />
  </div>
</template>

<script>
import { UserRoutes } from 'client/routes/RouteGenerator';
import ContextLogin from 'client/containers/Login/ContextLogin.vue';

export default {
  name: 'SsoLoginWrapper',

  props: {
    clientType: {
      type: String,
      required: true,
    },
    redirectTo: {
      type: String,
      default: '',
    },
    context: {
      type: String,
      required: true,
    },
  },
  components: {
    ContextLogin,
  },
  data() {
    return {
      completeRedirectUrl: UserRoutes.ssoRedirectUrl(this.redirectTo),
    };
  },
};
</script>
